'use client';

import { Box, Grid } from '@mantine/core';
import { CategoryCard } from './CategoryCard';
const items = [{
  image: '/assets/images/casino.png',
  colorFrom: '#FF99F3',
  colorTo: '#FF2980',
  title: 'Casino',
  des: "Explore PrimeRoll's originals games and enjoy over 5,000 classic casino titles."
}, {
  image: '/assets/images/battles.png',
  colorFrom: '#9B8DFF',
  colorTo: '#4654F9',
  title: 'Battles',
  des: 'Challenge friends or other players to exciting battles and win big prizes.'
}, {
  image: '/assets/images/prime.png',
  colorFrom: '#00E5CF',
  colorTo: '#39B54A',
  title: 'prime orbs',
  des: 'Unbox high-value prizes, from PrimeRoll NFTs to luxury items and more.'
}, {
  image: '/assets/images/live.png',
  colorFrom: '#3FBCFF',
  colorTo: '#3F7CFF',
  title: 'Live Games',
  des: 'Play real-time Blackjack, Baccarat, Roulette, and more with live dealers.'
}];
export const CategorySection: React.FC = () => {
  return <Box component="section" visibleFrom="sm">
      <Grid pt="md" grow>
        {items.map(item => <Grid.Col span={3} key={item.title} pt={24}>
            <CategoryCard image={item.image} colorFrom={item.colorFrom} colorTo={item.colorTo} title={item.title} des={item.des} />
          </Grid.Col>)}
      </Grid>
    </Box>;
};